import { clsx } from 'clsx';
import CircleLoader from 'components/common/CircleLoader';
import Checkbox from 'components/common/forms/Checkbox';
import Icon from 'components/common/Icon';
import Tooltip from 'components/common/Tooltip';

interface CheckboxCardProps {
  cardLabel: string;
  cardSubtitle: string;
  isSelected: boolean;
  onClick: () => void;
  price: string | undefined;
  toolTipText: string;
  isLoading: boolean;
}

const CheckboxCard = ({
  cardLabel,
  cardSubtitle,
  isSelected,
  onClick,
  price,
  toolTipText,
  isLoading,
}: CheckboxCardProps): JSX.Element => {
  return (
    <div
      className={clsx(
        'flex items-center justify-between gap-4 rounded-lg border p-4 cursor-pointer mt-4',
        isSelected
          ? 'border-primary-d-600 bg-[#F0F7F6]'
          : 'border-gray-d-300 bg-white',
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <Checkbox
          checked={isSelected}
          name={cardLabel}
          onChange={() => {}}
          tag="div"
        />
        <div className="flex flex-col">
          <div className="flex items-center gap-1.5">
            <span className="font-bold text-gray-900">{cardLabel}</span>
            <Tooltip
              trigger={
                <div className="flex w-3 h-3 text-gray-500 hover:text-gray-700">
                  <Icon id="info-circle" />
                </div>
              }
            >
              {toolTipText}
            </Tooltip>
          </div>
          <span className="text-sm text-gray-500">{cardSubtitle}</span>
        </div>
      </div>
      {isLoading ? (
        <CircleLoader isColored />
      ) : (
        <span className="font-bold text-gray-800">+{price}</span>
      )}
    </div>
  );
};

export default CheckboxCard;
